import { Box, Modal } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FC, ReactElement, useState } from "react";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const CustomModal: FC<CustomModalProps> = ({ ModalOpenButton, disableBackdropClick = false, children }) => {
  const classes = useStyles({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = (e: any) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };
  const handleOpenModal = (e: any) => {
    e.stopPropagation();
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Box display="inline-block" onClick={handleOpenModal}>
        {ModalOpenButton}
      </Box>
      <Modal
        className={classes.modal}
        open={isModalOpen}
        onClose={handleCloseModal}
        children={<>{typeof children === "function" ? (children as any)({ handleCloseModal }) : children}</>}
        disableBackdropClick={disableBackdropClick}
      />
    </div>
  );
};

interface CustomModalProps {
  ModalOpenButton: ReactElement;
  disableBackdropClick?: boolean;
}

export default CustomModal;
